module.exports = __webpack_public_path__ + "img/4.1a494540.jpg";